import { loadHtml2Canvas } from '@/utils/html2canvas-loader';
import { IMAGE_DOWNLOAD_FILE_FORMATS } from '@/app/dashboards/constants';
import { env } from '@/env';

export async function downloadImage(element, format) {
  const html2canvas = await loadHtml2Canvas();
  html2canvas(element, {
    backgroundColor: '#ffffff',
    scale: 2,
    proxy: `${env.dashboardApiUrl}export_proxy`,
    onclone: (clonedDoc) => {
      // Force white background on all elements to prevent monitor-specific color variations
      clonedDoc.body.style.backgroundColor = '#ffffff';
      clonedDoc.documentElement.style.backgroundColor = '#ffffff';

      clonedDoc.querySelectorAll('.image-download, .see-more-button').forEach((item) => {
        item.style.display = 'none';
      });

      clonedDoc.querySelectorAll('.avatar-outer').forEach((item) => {
        item.style.padding = '0.3125rem';
        item.style.borderRadius = '100%';
        item.style.border = '1px solid #D2D1D1';
      });

      clonedDoc.querySelectorAll('.media').forEach((mediaDiv) => {
        // This is done to preserve image scaling in screenshot
        mediaDiv.querySelectorAll('img').forEach((img) => {
          const div = document.createElement('div');
          div.style.width = '100%';
          div.style.height = '100%';
          div.style.backgroundImage = `url('${img.src}')`;
          div.style.backgroundSize = 'cover';
          div.style.backgroundPosition = 'center';

          // Replace the img with the new div
          img.parentNode.replaceChild(div, img);
        });
      });
    },
  }).then((canvas) => {
    const formatKey = format.toUpperCase();
    const imageFormatKey = IMAGE_DOWNLOAD_FILE_FORMATS[formatKey];
    const dataURL = canvas.toDataURL(imageFormatKey.dataUrl);
    const url = dataURL.replace(/^data:image\/[^;]/, 'data:application/octet-stream');
    const link = document.createElement('a');
    const title = 'Widget PNG';

    if (title) {
      link.download = `${title}.${imageFormatKey.extension}`;
    } else {
      link.download = `DH Report.${imageFormatKey.extension}`;
    }
    link.href = url;
    link.click();
  });
}
